#import '../queries/UserDetails.graphql'
mutation UpdateUser(
  $userData: UserInput!
  $torahMelodies: [ID!]!
  $haftarahMelodies: [ID!]!
  $sentenceGroupMelodies: [ID!]!
  $pronunciations: [ID!]!
  $tags: [String!]!
  $font: String!
  $fontSize: Int!
  $lineHeight: Float!
  $gender: String!
  $kamatzKatanColor: String
  $shewaNaColor: String
) {
  updateUser(
    userData: $userData
    torahMelodies: $torahMelodies
    haftarahMelodies: $haftarahMelodies
    sentenceGroupMelodies: $sentenceGroupMelodies
    pronunciations: $pronunciations
    tags: $tags
    font: $font
    fontSize: $fontSize
    lineHeight: $lineHeight
    gender: $gender
    kamatzKatanColor: $kamatzKatanColor
    shewaNaColor: $shewaNaColor
  ) {
    ok
    errors
    user {
      ...userDetails
    }
  }
}
